var _excluded = ["items", "main"],
  _excluded2 = ["icon"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import shouldShowItemForLocale from './l10n';
import { interpolateLinkForLocale, Locale, LocaleValues } from '../../common/l10n';
import getIcon from '../../common/icons';
export function getItems(_ref) {
  var locale = _ref.locale,
    _ref$isUserLoggedIn = _ref.isUserLoggedIn,
    isUserLoggedIn = _ref$isUserLoggedIn === void 0 ? false : _ref$isUserLoggedIn,
    _ref$hasUserPreviousl = _ref.hasUserPreviouslyLoggedIn,
    hasUserPreviouslyLoggedIn = _ref$hasUserPreviousl === void 0 ? false : _ref$hasUserPreviousl,
    _ref$revealHiddenItem = _ref.revealHiddenItemsList,
    revealHiddenItemsList = _ref$revealHiddenItem === void 0 ? [] : _ref$revealHiddenItem,
    registerLink = _ref.registerLink,
    items = _ref.items,
    isPillNavigation = _ref.isPillNavigation;
  return items.filter(function (item) {
    return shouldShowItem(item, revealHiddenItemsList);
  }).filter(function (item) {
    return shouldShowItemForLocale(item, locale);
  }).filter(function (item) {
    return shouldShowItemForUser(item, isUserLoggedIn);
  }).filter(function (item) {
    return shouldShowItemForPreviouslyLoggedUser(item, hasUserPreviouslyLoggedIn);
  }).filter(function (item) {
    return shouldShowItemForPillNav(item, isPillNavigation);
  }).filter(function (item) {
    return shouldShowItemByLocale(item, locale);
  }).map(function (item) {
    return filterHiddenSubItems(item, revealHiddenItemsList, locale);
  }).map(function (item) {
    return localizeItem(item, locale);
  }).map(function (item) {
    return useCustomRegisterLink(item, registerLink);
  }).map(addIconToItemIfExists);
}
export function getButtonItems(_ref2) {
  var locale = _ref2.locale,
    isUserLoggedIn = _ref2.isUserLoggedIn,
    _ref2$hasUserPrevious = _ref2.hasUserPreviouslyLoggedIn,
    hasUserPreviouslyLoggedIn = _ref2$hasUserPrevious === void 0 ? false : _ref2$hasUserPrevious,
    registerLink = _ref2.registerLink,
    items = _ref2.items;
  return items.filter(function (item) {
    return shouldShowItemForUser(item, isUserLoggedIn);
  }).filter(function (item) {
    return shouldShowItemForPreviouslyLoggedUser(item, hasUserPreviouslyLoggedIn);
  }).map(function (item) {
    return localizeLinkInItem(item, locale);
  }).map(function (item) {
    return useCustomRegisterLink(item, registerLink);
  });
}
function useCustomRegisterLink(item, registerLink) {
  if (item.id === 'register' && registerLink) {
    return _objectSpread(_objectSpread({}, item), {}, {
      link: registerLink
    });
  }
  return item;
}
function localizeItem(item, locale) {
  return item.items ? localizeItemWithSubitems(item, locale) : localizeItemWithoutSubitems(item, locale);
}
function localizeItemWithSubitems(_ref3, locale) {
  var items = _ref3.items,
    main = _ref3.main,
    item = _objectWithoutProperties(_ref3, _excluded);
  var subitems = items.filter(function (subitem) {
    return shouldShowItemForLocale(subitem, locale);
  }).map(function (subitem) {
    return localizeLinkInItem(subitem, locale);
  });
  var localizedMainItem = main ? localizeItemWithoutSubitems(main, locale) : undefined;
  var localizedParentItem = localizeItemWithoutSubitems(item, locale);
  return _objectSpread(_objectSpread({}, localizedParentItem), {}, {
    items: subitems,
    main: localizedMainItem
  });
}
function localizeItemWithoutSubitems(item, locale) {
  return localizeLinkInItem(item, locale);
}
function localizeLinkInItem(item, locale) {
  var isLocaleAvailable = item.availableLocales ? item.availableLocales.includes(locale) : LocaleValues.includes(locale);
  if (item.link) {
    return _objectSpread(_objectSpread({}, item), {}, {
      link: interpolateLinkForLocale(item.link, isLocaleAvailable ? locale : Locale.GB)
    });
  }
  return item;
}
function addIconToItemIfExists(_ref4) {
  var icon = _ref4.icon,
    item = _objectWithoutProperties(_ref4, _excluded2);
  return icon ? _objectSpread(_objectSpread({}, item), {}, {
    Icon: getIcon(icon)
  }) : item;
}
function shouldShowItemForUser(item, isUserLoggedIn) {
  var noUserLogic = !item.showForLoggedInUser && !item.hideForLoggedInUser;
  if (noUserLogic || isUserLoggedIn && item.showForLoggedInUser || !isUserLoggedIn && item.hideForLoggedInUser) {
    return true;
  }
  return false;
}
function shouldShowItemForPreviouslyLoggedUser(item, hasUserPreviouslyLoggedIn) {
  if (Object.prototype.hasOwnProperty.call(item, 'showForPreviouslyLoggedInUser')) {
    return hasUserPreviouslyLoggedIn === item.showForPreviouslyLoggedInUser;
  }
  return true;
}
function shouldShowItem(item, revealItemsList) {
  if (!item.id || item.id && !item.hidden) {
    return true;
  }
  if (item.hidden === true && revealItemsList.indexOf(item.id) !== -1) {
    return true;
  }
  return false;
}
function shouldShowItemByLocale(item, locale) {
  if (item.hiddenLocale && item.hiddenLocale.indexOf(locale) !== -1) {
    return false;
  }
  if (item.showForLocale && !item.showForLocale.includes(locale)) {
    return false;
  }
  return true;
}
function filterHiddenSubItems(item, revealItemsList, locale) {
  var filteredItem = Object.assign({}, item);
  if (filteredItem.items) {
    filteredItem.items = filteredItem.items.filter(function (subItem) {
      return shouldShowItem(subItem, revealItemsList);
    }).filter(function (subItem) {
      return shouldShowItemByLocale(subItem, locale);
    });
  }
  return filteredItem;
}
function shouldShowItemForPillNav(item, isPillNavigation) {
  if (item.hideInPillNavigation && isPillNavigation) {
    return false;
  }
  if (item.showInPillNavigation && !isPillNavigation) {
    return false;
  }
  return true;
}